<template>
<v-container style="max-width: 1100px">
  <Presentation v-if="schema.schema_presentation_id > 0" :schema="schema" />
  <v-card-title class="headline form-fill-header">{{ formName }}</v-card-title>
  <div style="margin-top:20px" v-for="field in fields" :key="field.id">
    <component v-if="!isHiddenField(field)" :field="field" :is="getInputComponent(field.type)" :context="Context.createFormContextWithFields(fields)" :value="getValue(field.order)" @setValue="setValue($event, field.order)">
    </component>
  </div>

  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn v-if="schema.type != schemaType.TEST" :disabled="loading" large round class="primary" @click="submit(states.SAVED)">{{ $t("base.save") }}</v-btn>
    <v-btn :disabled="loading" large round class="primary" @click="submit(states.COMPLETED)">{{ $t("base.submit") }}</v-btn>
  </v-card-actions>
</v-container>
</template>

<script>
import schemaType from '@/enums/schemaType'
import http from "@/plugins/http"
import TextInput from "./inputs/Text"
import NumberInput from "./inputs/Number"
import DateInput from "./inputs/Date"
import TimeInput from "./inputs/Time"
import RadioInput from "./inputs/Radio"
import TableInput from "./inputs/Table"
import MultipleInput from "./inputs/Multiple"
import SignatureInput from "./inputs/Signature"
import PhotoInput from "./inputs/Photo"
import CodeInput from "./inputs/Code"
import ArchiveInput from "./inputs/Archive"
import RelatedInput from "./inputs/Related"
import DependInput from "./inputs/SelectDepend"
import CheckboxInput from "./inputs/Checkbox"
import StorageInput from "./inputs/Storage"
import states from '@/enums/states'
import fieldType from '@/enums/fieldType'
import Context from '@/plugins/Context'
import Presentation from './Presentation'
import Messenger from "@/plugins/Messenger"

export default {
  name: "Fill",
  components: {
    TextInput,
    NumberInput,
    DateInput,
    TimeInput,
    RadioInput,
    TableInput,
    MultipleInput,
    SignatureInput,
    PhotoInput,
    CodeInput,
    ArchiveInput,
    RelatedInput,
    DependInput,
    CheckboxInput,
    Presentation,
    StorageInput
  },
  data() {
    return {
      schemaType : schemaType,
      formName: "",
      fields: [],
      states: states,
      payload: {
        results: []
      },
      schema: {},
      loading: false,
      Context,
      Messenger
    }
  },
  watch: {
    '$store.state.lang': function () {
      this.loadSchema()
    }
  },
  created() {
    this.loadSchema()
  },
  methods: {
    isHiddenField(field) {
      return fieldType.hidden.includes(field.type)
    },
    getInputComponent(type) {
      return type + "-input"
    },
    getFieldValue(id) {
      let field = this.getFieldInfo(id)
      if (!field) return undefined

      let cell = this.payload.results.find(cell => cell.order == field.order)
      if (cell) {
        return cell.value
      }
    },
    getValue(order) {
      let cell = this.payload.results.find(cell => cell.order == order)
      if (cell) {
        return cell.value
      }
      return ''
      
    },
    setValue(value, order) {
      let cell = this.payload.results.find(cell => cell.order == order)
      if (cell) {
        cell.value = value
      } else {
        this.payload.results.push({
          order,
          value
        })
      }

      this.$store.commit('setFormPayload', this.payload)
    },
    getFieldInfo(id) {
      return this.fields.find(field => field.id == id)
    },
    submit(state) {
      if(this.schema.all_fields_required && !this.checkAllRequiredFields(this.payload.results)){
        Messenger.emitError(this.$t('form.fill.complete_all_fields'))
        return
      }
      this.loading = true
      this.payload.state = state
      this.payload.lang = this.$store.getters.lang
      http.post('form/' + this.$route.params.schemaId + '/fill', this.payload)
        .then((data) => {
          this.loading = false
          this.$store.commit("setSnack", {
            "message": this.$t("form.fill.success-message", {
              "form-name": this.formName
            }),
            "color": "success"
          })
          this.redirectAfterFill(data.data.id)

        })
    },
    checkAllRequiredFields(results){
      for(let key in results){
        let val = results[key].value

        if(!val){
          return false
        }

        if(Array.isArray(val)){
          if(val.length==0){
            return false
          }
          // TODO Check records tabel
        }
      }

      return true
    },
    redirectAfterFill(idForm) {
      let params = {
        schemaId: this.$route.params.schemaId
      }
      let name = "form-view"

      if (this.schema.type == schemaType.TEST) {
        params.formId = idForm
        name = 'single-form-view'
      }
      this.$router.push({
        name,
        params
      })
    },
    loadSchema(){
      this.loading = true
      http.get('schema/' + this.$route.params.schemaId + '/' + this.$store.state.lang)
          .then(({data}) => {
            this.loading = false
            this.fields = data.fields
            this.schema = data
            this.formName = data.name
          }).catch(() => {
        this.$route.push({
          name: "not-found"
        })
        })
    }
  },
}
</script>

<style>
.form-fill-header {
  margin: 11px;
}

.v-list__tile {
  height: auto;
  margin: 16px 0;
}
</style>
